import * as React from "react";
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Box from "@mui/material/Box/Box";
import Button from "@mui/material/Button/Button";
import Stack from "@mui/material/Stack";
import {useNavigate} from "react-router-dom";
import firebase from '../../firebase/firebase'
import {AuthUserContext} from "../../providers/AuthProvider";
import ScrollToTop from "../../utils/scrollTop";

function PortofolioProjectDetail({ parentcallback, data }) {
	const dateConverter = (date) => {
		const [year, month, day] = date.split('-');

		const result = `${month}/${day}/${year}`;
		return result
	  }
	const { project = data } = data;
	const { profile } = React.useContext(AuthUserContext);
	const navigate = useNavigate()

	const removeProject = () => {
		const userRef = firebase.firestore().collection('users').doc(profile.id);
		userRef.get()
		.then(async (doc) => {
			if (doc?.data() && doc?.data()?.portfolio) {
				let portfolio = doc?.data()?.portfolio.filter((_project) => {
					return _project.title !== project.title;
				})
				await userRef.update({portfolio: portfolio});
				navigate('/creator/dashboard');
			}
		});
	}
	// console.log(project)
	return (
		<React.Fragment>
			<ScrollToTop/>
			<Container
				maxWidth="fullWidth"
				sx={{ backgroundColor: "#E3E8F0", paddingY: 3, marginY: 0 }}>
				<Container maxWidth="md" sx={{ textAlign: "left" }}>
					<Typography
						variant={"h4"}
						color={"primary"}
						sx={{ marginY: 5, textTransform: "capitalize" }}>
						{project?.title}
					</Typography>
				</Container>
			</Container>
			<Container maxWidth="md" sx={{ textAlign: "left", pb: 5, mt: 5 }}>
			{profile?.userType === 'creator' && 
			<>
				<Stack direction={"column"} spacing={3} sx={{ width: "100%" }}>
					
					
					<img
						src={project?.media?.cover}
						style={{
							width: "100%",
							height: 110,
							objectFit: "cover",
							borderRadius: "10px",
						}}
					/>

					<Stack direction={"row"} spacing={3} sx={{ width: "100%" }}>
						<img
							src={project?.media?.image}
							alt={project?.title + "image"}
							style={{
								width: 200,
								height: 300,
								objectFit: "cover",
								borderRadius: "10px",
							}}
						/>
						<video controls
							//loop={true}
							src={project?.media?.trailer}
							// autoPlay ={false}
							style={{
								width: "100%",
								height: 300,
								borderRadius: "14px",
								objectFit: "cover",
								backgroundColor: "whitesmoke",
							}}
						/>
					</Stack>
					
					{/* {
						profile?.userType === 'artist' && 
						<>
							<img
							src={project?.media?.cover}
							style={{
								width: "100%",
								height: 300,
								objectFit: "cover",
								borderRadius: "10px",
							}}
							/>
						</>
					} */}
					<Stack
						direction={"column"}
						spacing={5}
						sx={{ width: "100%", pt: 5 }}>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Project Title
						</Typography>
						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.title}
						</Typography>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Description / Logline
						</Typography>

						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.description}
						</Typography>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Project type
						</Typography>
						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.type}
						</Typography>
						<Stack
							direction={"row"}
							spacing={5}
							sx={{ width: "100%" }}>
							<Stack
								direction={"column"}
								spacing={5}
								style={{ flex: 1 }}>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										textTransform: "uppercase",
									}}>
									Production Start Date
								</Typography>
								<Typography
									variant={"body1"}
									color={"text.secondary"}
									sx={{ textTransform: "capitalize" }}>
									{dateConverter(project?.startDate)}
									
								</Typography>
							</Stack>
							<Stack
								direction={"column"}
								spacing={5}
								style={{ flex: 1 }}>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										textTransform: "uppercase",
									}}>
									Production End Date
								</Typography>
								<Typography
									variant={"body1"}
									color={"text.secondary"}
									sx={{ textTransform: "capitalize" }}>
									{dateConverter(project?.endDate)}
								</Typography>
							</Stack>
						</Stack>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Your role
						</Typography>

						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.role}
						</Typography>

						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Genre
						</Typography>
						
						<Stack
						direction={'row'} spacing={1}>
						{project?.genre && project?.genre.length>0 &&
						 Array.isArray(project?.genre) ? //Added this condition cause the older projects were breaking as they werent saved in array
						project?.genre.map((genres, i)=>
							<Typography
							key={i}
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
								{genres},
							</Typography>
								)
							:
							<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							 {project?.genre}
							</Typography> 
							}
						</Stack>
						
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Language
						</Typography>

						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.language}
						</Typography>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							PRIMARY FILM LOCATION
						</Typography>

						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.location}
						</Typography>
						<Typography
							variant={"h5"}
							color={"primary"}
							sx={{
								borderBottom: "1px solid",
								textTransform: "uppercase",
							}}>
							Synopsis
						</Typography>

						<Typography
							variant={"body1"}
							color={"text.secondary"}
							sx={{ textTransform: "capitalize" }}>
							{project?.synopsis}
						</Typography>
						
						{project?.website ? 
						<>
							<Typography
								variant={"h5"}
								color={"primary"}
								sx={{
									borderBottom: "1px solid",
									textTransform: "uppercase",
								}}>
								Website
							</Typography>

							<Typography variant={"body1"} color={"text.secondary"}>
								<a href={project?.website} target={"_blank"}>
									{project?.website}
								</a>
							</Typography>
						</> : <></>
						}

						{
							(project?.imdb) ?
							<>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										
									}}>
									IMDb
								</Typography>

								<Typography variant={"body1"} color={"text.secondary"}>
									<a href={project?.imdb} target={"_blank"}>
										{project?.imdb}
									</a>
								</Typography>
							</> : 
							<></>
						}
						
						{
							(project?.vimeo) ? 
							<>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										textTransform: "uppercase",
									}}>
									Vimeo
								</Typography>

								<Typography variant={"body1"} color={"text.secondary"}>
									<a href={project?.vimeo} target={"_blank"}>
										{project?.vimeo}
									</a>
								</Typography>
							</> : 
							<></>
						}
						
						{
							(project?.facebook) ? 
							<>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										textTransform: "uppercase",
									}}>
									Facebook
								</Typography>

								<Typography variant={"body1"} color={"text.secondary"}>
									<a href={project?.facebook} target={"_blank"}>
										{project?.facebook}
									</a>
								</Typography>
							</> : 
							<></>
						}
						
						{
							(project?.instagram) ? 
							<>
								<Typography
									variant={"h5"}
									color={"primary"}
									sx={{
										borderBottom: "1px solid",
										textTransform: "uppercase",
									}}>
									Instagram
								</Typography>

								<Typography variant={"body1"} color={"text.secondary"}>
									<a href={project?.instagram} target={"_blank"}>
										{project?.instagram}
									</a>
								</Typography>
							</> : 
							<></>
						}
						

						<Stack
							direction={"row"}
							spacing={5}
							sx={{ width: "100%" }}
							justifyContent="center"
							alignItems="center">
							<Button
								sx={{
									textDecoration: "underline",
									pt: 1.2,
									pb: 1.2,
									pl: 5,
									pr: 5,
								}}
								onClick={() => removeProject()}
								>
								Remove project
							</Button>
							<Button
								variant={"contained"}
								sx={{ pt: 1.2, pb: 1.2, pl: 5, pr: 5 }}
								onClick={() =>
									parentcallback(
										true,
										project.index,
										project,
										"edit"
									)
								}>
								Edit project
							</Button>
						</Stack>
					</Stack>
				</Stack>
				</>}
				{
					profile?.userType === 'artist' &&
					<>
						<Stack direction={"row"} spacing={3} sx={{ width: "100%" }}>
						<img
							src={project?.media?.cover}
							style={{
								width: 200,
								height: 350,
								objectFit: "cover",
								borderRadius: "6px",
							}}
						/>
						<Stack direction={'column'} justifyContent="center"
                           	alignItems="flex-start" spacing={3} >

                      		<span />

                      		<Stack direction={'column'} justifyContent="center"
                            alignItems="flex-start" spacing={3}>
								<Typography variant={'body1'} color={'primary'}>
								Description:
								</Typography>
								<Typography variant={'body2'} color={'secondary'}>
								{project?.synopsis || project?.description}
								</Typography>

                      		</Stack>

							<Stack direction={'row'} justifyContent="flex-start"
                             	alignItems="center" spacing={3}>
								<Typography variant={'body1'} color={'primary'}>
								Role:
								</Typography>
								<Typography variant={'body1'} color={'secondary'}>
								{project?.type || project?.role}
								</Typography>

                      		</Stack>
							
							<a style={{color: "#363636", fontSize: "16px"}} href={project?.imdb} target="_blank" rel="noreferrer">Link to IMDb</a>
			
							
						</Stack>
					</Stack>
					<Stack>
							<Typography variant={'h6'} sx={{ marginY: 5, textTransform: "capitalize" }} color={'primary'}>
								Media Gallery
							</Typography>

							<Stack direction={"row"} spacing={3} sx={{ width: "100%" }}>
							{project?.media?.gallery && project?.media?.gallery.length>0 &&
								project?.media?.gallery.map((media, id)=>
									<img
									key={id}
									src={media.src}
									style={{
										width: 125,
										height: 125,
										objectFit: "cover",
									}}
									/>
									)
							}
							</Stack>

					</Stack>
					<Stack
							direction={"row"}
							spacing={5}
							sx={{ marginY: 5, width: "100%" }}
							justifyContent="center"
							alignItems="center">
							<Button
								sx={{
									textDecoration: "underline",
									pt: 1.2,
									pb: 1.2,
									pl: 5,
									pr: 5,
								}}
								onClick={() => removeProject()}
								>
								Remove project
							</Button>
							<Button
								variant={"contained"}
								sx={{ pt: 1.2, pb: 1.2, pl: 5, pr: 5,textTransform:"capitalize" }}
								onClick={() =>
									parentcallback(
										true,
										project.index,
										project,
										"edit"
									)
								}>
								Edit project
							</Button>
					</Stack>
					
					</>
				}
			</Container>
		</React.Fragment>
	);
}

export default PortofolioProjectDetail;
